export var ActionTypeEnum;
(function (ActionTypeEnum) {
    ActionTypeEnum["UNKNOWN"] = "UNKNOWN";
    ActionTypeEnum["URL"] = "URL";
    ActionTypeEnum["EVENT"] = "EVENT";
    ActionTypeEnum["CALLBACK"] = "CALLBACK";
})(ActionTypeEnum || (ActionTypeEnum = {}));
export var ActionTargetEnum;
(function (ActionTargetEnum) {
    ActionTargetEnum["UNKNOWN"] = "UNKNOWN";
    ActionTargetEnum["NEW_TAB"] = "NEW_TAB";
    ActionTargetEnum["SAME_TAB"] = "SAME_TAB";
})(ActionTargetEnum || (ActionTargetEnum = {}));
export var UnauthorizedHandleType;
(function (UnauthorizedHandleType) {
    UnauthorizedHandleType["HIDDEN"] = "HIDDEN";
    UnauthorizedHandleType["DISABLED"] = "DISABLED";
})(UnauthorizedHandleType || (UnauthorizedHandleType = {}));
export var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["UNSET"] = "";
    ButtonStyle["ERROR"] = "ERROR";
    ButtonStyle["WARNING"] = "WARNING";
    ButtonStyle["SUCCESS"] = "SUCCESS";
    ButtonStyle["INFO"] = "INFO";
    ButtonStyle["PRIMARY"] = "PRIMARY";
})(ButtonStyle || (ButtonStyle = {}));
export var ButtonType;
(function (ButtonType) {
    ButtonType["UNSET"] = "";
    ButtonType["FLAT"] = "FLAT";
    ButtonType["OUTLINE"] = "OUTLINE";
    ButtonType["SOLID"] = "SOLID";
})(ButtonType || (ButtonType = {}));
export var MenuItemButtonStyle;
(function (MenuItemButtonStyle) {
    MenuItemButtonStyle["ERROR"] = "ERROR";
    MenuItemButtonStyle["WARNING"] = "WARNING";
    MenuItemButtonStyle["DISABLED"] = "DISABLED";
})(MenuItemButtonStyle || (MenuItemButtonStyle = {}));
export var HeightUnitOfMeasurement;
(function (HeightUnitOfMeasurement) {
    HeightUnitOfMeasurement["PX"] = "PX";
    HeightUnitOfMeasurement["VH"] = "VH";
})(HeightUnitOfMeasurement || (HeightUnitOfMeasurement = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZGVscy9jb21tb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsTUFBTSxDQUFOLElBQVksY0FLWDtBQUxELFdBQVksY0FBYztJQUN0QixxQ0FBbUIsQ0FBQTtJQUNuQiw2QkFBVyxDQUFBO0lBQ1gsaUNBQWUsQ0FBQTtJQUNmLHVDQUFxQixDQUFBO0FBQ3pCLENBQUMsRUFMVyxjQUFjLEtBQWQsY0FBYyxRQUt6QjtBQUVELE1BQU0sQ0FBTixJQUFZLGdCQUlYO0FBSkQsV0FBWSxnQkFBZ0I7SUFDeEIsdUNBQW1CLENBQUE7SUFDbkIsdUNBQW1CLENBQUE7SUFDbkIseUNBQXFCLENBQUE7QUFDekIsQ0FBQyxFQUpXLGdCQUFnQixLQUFoQixnQkFBZ0IsUUFJM0I7QUFFRCxNQUFNLENBQU4sSUFBWSxzQkFHWDtBQUhELFdBQVksc0JBQXNCO0lBQzlCLDJDQUFpQixDQUFBO0lBQ2pCLCtDQUFxQixDQUFBO0FBQ3pCLENBQUMsRUFIVyxzQkFBc0IsS0FBdEIsc0JBQXNCLFFBR2pDO0FBaUtELE1BQU0sQ0FBTixJQUFZLFdBT1g7QUFQRCxXQUFZLFdBQVc7SUFDbkIseUJBQVUsQ0FBQTtJQUNWLDhCQUFlLENBQUE7SUFDZixrQ0FBbUIsQ0FBQTtJQUNuQixrQ0FBbUIsQ0FBQTtJQUNuQiw0QkFBYSxDQUFBO0lBQ2Isa0NBQW1CLENBQUE7QUFDdkIsQ0FBQyxFQVBXLFdBQVcsS0FBWCxXQUFXLFFBT3RCO0FBRUQsTUFBTSxDQUFOLElBQVksVUFLWDtBQUxELFdBQVksVUFBVTtJQUNsQix3QkFBVSxDQUFBO0lBQ1YsMkJBQWEsQ0FBQTtJQUNiLGlDQUFtQixDQUFBO0lBQ25CLDZCQUFlLENBQUE7QUFDbkIsQ0FBQyxFQUxXLFVBQVUsS0FBVixVQUFVLFFBS3JCO0FBT0QsTUFBTSxDQUFOLElBQVksbUJBSVg7QUFKRCxXQUFZLG1CQUFtQjtJQUMzQixzQ0FBZSxDQUFBO0lBQ2YsMENBQW1CLENBQUE7SUFDbkIsNENBQXFCLENBQUE7QUFDekIsQ0FBQyxFQUpXLG1CQUFtQixLQUFuQixtQkFBbUIsUUFJOUI7QUFFRCxNQUFNLENBQU4sSUFBWSx1QkFHWDtBQUhELFdBQVksdUJBQXVCO0lBQy9CLG9DQUFTLENBQUE7SUFDVCxvQ0FBUyxDQUFBO0FBQ2IsQ0FBQyxFQUhXLHVCQUF1QixLQUF2Qix1QkFBdUIsUUFHbEMifQ==